import type { ComponentType } from 'react';

import Loadable from 'react-loadable';

import type { RovodalLoadableCanvasProps } from '@atlassian/rovodal-context/types';

export const AsyncBlastRadiusCanvas: ComponentType<RovodalLoadableCanvasProps> = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlassian/ai-mate-jira-admin-agent-blast-radius-canvas" */
			'./BlastRadiusCanvas'
		).then((m) => m.BlastRadiusCanvas),
	loading: () => null,
});
